import { updateGroupInfo as apiUpdateGroupInfo } from 'APP/model/group/groupModel';
import Entities from 'STORE';

export const updateGroupInfo = async (data) => {
  try {
    // SERVER IS SENSITIVE TO NULL VALUES, DON'T CHANGE THEM
    const personalizedGroup = await apiUpdateGroupInfo({
      groupId: data.groupId,
      avatarUrl: data.avatarUrl || null,
      name: (data.name || '').trim(),
      description: data.description || '',
      groupType: data.type,
      categoryId: data.categoryId || '',
      donationUrl: data.donationUrl || '',
      tags: [],
      deepLinkAlias: data.deepLinkAlias || null, // keep previous deep link
    });

    if (personalizedGroup) {
      Entities.GroupsStore.merge([personalizedGroup]);
    }
  } catch (_error) {
    // do nothing
  }
};
